export * from './app-footer.component';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-footer/index.ts